import { publicAsset } from '@/config/appPaths';

export const PROGRAM_CTA_URL = 'https://www.bascperu.org/detalle-curso-basc.php?id=2010#curso-formulario';
export const PROGRAM_WEBSITE = 'https://www.bascperu.org/detalle-curso-basc.php?id=2010';

export const WHATSAPP_PHONE = '51981289782';

export const programContent = {
  meta: {
      title:
        'I Programa Especializado Internacional | Gestión y Seguridad Portuaria | BASC Perú Training',
      description:
        'Inicio 10 ago 2026. 120 horas híbridas, hasta 7 certificaciones y Misión académica internacional en Panamá. BASC Perú Training',
    },
    hero: {
      badge: 'Inscripciones abiertas · Inicio 10 de agosto de 2026',
      pretitle: 'I Programa especializado internacional · BASC Perú Training',
      title:
        'Especialista en la gestión, seguridad y protección de operaciones portuarias en la cadena de suministro del comercio exterior',
      subtitle:
        'Programa intensivo que integra normativa internacional, gestión operativa portuaria y experiencia práctica real. Modalidad híbrida con inicio presencial de cada módulo',
      slogan:
        'Conecta tu carrera con el mundo: certifícate y vive la experiencia logística en Panamá',
      cta: 'QUIERO INSCRIBIRME',
      stats: '120 horas académicas · Modalidad híbrida · ',
      statsHighlight: 'MISIÓN ACADÉMICA INTERNACIONAL EN PANAMÁ',
      scrollCta: 'Descubre los beneficios del programa',
      form: {
        title: 'Regístrate aquí para más información',
        fields: {
          firstName: 'Nombre*',
          paternalLastName: 'Apellido Paterno*',
          maternalLastName: 'Apellido Materno*',
          dni: 'DNI',
          phone: 'Celular*',
          email: 'Email*',
          interest: 'Seleccione una opción',
        },
        interestOptions: [
          { value: '', label: 'Seleccione una opción' },
          { value: 'enroll', label: 'Me interesa el programa teórico' },
          { value: 'info', label: 'Me interesa el viaje académico en Panamá' },
          { value: 'company', label: 'Me interesa el programa teórico y el viaje académico en Panamá' },
          { value: 'other', label: 'Otro' },
        ],
        dataConsent:
          'Autorizo el tratamiento de mis datos personales para finalidades informativas y comerciales, conforme al siguiente enlace. Sin mi autorización, no podrán comunicarse conmigo. *',
        commercialConsent:
          'Opcionalmente, autorizo el tratamiento de mis datos personales para las Finalidades Comerciales Adicionales descritas en el siguiente enlace.',
        privacyLinkLabel: 'enlace',
        privacyUrl: 'https://www.bascperu.org',
        submit: 'Quiero más información',
        successMessage:
          'Gracias por registrarte. Nos pondremos en contacto contigo a la brevedad',
      },
    },
    featureBar: {
      items: [
        {
          icon: 'fa-shield-halved',
          text: 'Integración de seguridad (BASC, OEA, CTPAT, 28000) con operatividad portuaria avanzada',
        },
        {
          icon: 'fa-plane',
          text: 'Hasta 7 certificaciones de alto prestigio nacional e internacional',
        },
        {
          icon: 'fa-award',
          text: 'Misión académica internacional en Panamá: Canal, Zona Libre y Zona Economía',
        },
        {
          icon: 'fa-globe',
          text: 'Conexión directa con operadores del Hub Logístico',
        },
      ],
    },
    programPreview: {
      pretitle: 'Conoce el programa en 1 minuto',
      title:
        'Descubre lo que vivirás en el programa y en la misión académica en Panamá',
      items: [
        '120 horas híbridas: teoría en vivo + práctica presencial',
        'Hasta 7 certificaciones de prestigio nacional e internacional',
        'Misión académica internacional en el hub logístico de Panamá',
      ],
      videoUrl: 'https://youtube.com/shorts/PlAT46WN1Ck?feature=share',
      videoTitle: 'Programa Especializado Internacional BASC Perú Training',
    },
    registrationSection: {
      title: 'Regístrate aquí para más información',
    },
    audience: {
      title: 'Este programa es para ti si…',
      subtitle:
        'Eres un profesional que busca liderazgo en logística, operaciones portuarias y seguridad en el comercio exterior',
      items: [
        'Buscas desempeñar una gerencia de logística, operaciones portuarias y protección portuaria',
        'Quieres fortalecer tu perfil profesional en seguridad y protección portuaria en terminales e instalaciones críticas',
        'Deseas desarrollar competencias en seguridad en la cadena de suministro del comercio exterior',
        'Buscas integrar BASC, OEA, CTPAT e ISO 28000 con operatividad portuaria avanzada',
        'Quieres hasta 7 certificaciones de alto prestigio nacional e internacional',
        'Deseas la Misión académica internacional en Panamá y conexión con operadores del hub logístico',
      ],
      cta: 'QUIERO UNIRME AL PROGRAMA',
      scrollCta: 'Conoce la misión académica en Panamá',
    },
    experience: {
      scrollCta: 'Explora el contenido del programa',
    },
    value: {
      title: '¿Qué es este programa?',
      programName:
        'Especialista en la gestión, seguridad y protección de operaciones portuarias en la cadena de suministro del comercio exterior',
      text: 'es un programa intensivo que integra normativa internacional, gestión operativa portuaria y experiencia práctica real. En 120 horas de especialización desarrollarás competencias para identificar, prevenir y gestionar riesgos en la cadena logística marítima, con visita académica internacional en Panamá',
    },
    outcomes: {
      title: 'Lo que te llevas al especializarte',
      items: [
        {
          icon: 'fa-shield-halved',
          title: 'Seguridad + operatividad portuaria',
          desc: 'Integración de BASC, OEA, CTPAT e ISO 28000 con operatividad portuaria avanzada',
        },
        {
          icon: 'fa-award',
          title: 'Hasta 7 certificaciones',
          desc: 'Certificaciones de alto prestigio nacional e internacional vinculadas al programa',
        },
        {
          icon: 'fa-plane',
          title: 'Misión académica internacional en Panamá',
          desc: 'Canal de Panamá, Zona Libre y Zona de Economía Especial con enfoque teórico-práctico',
        },
        {
          icon: 'fa-globe',
          title: 'Hub logístico internacional',
          desc: 'Conexión directa con operadores del hub logístico y buenas prácticas regionales',
        },
        {
          icon: 'fa-laptop',
          title: 'Modalidad híbrida',
          desc: 'Inicio presencial de cada módulo combinado con contenido académico estructurado',
        },
        {
          icon: 'fa-clock',
          title: '120 horas de especialización',
          desc: 'Ruta completa en 6 módulos, incluyendo 40 horas de curso internacional en Panamá',
        },
      ],
      cta: 'QUIERO ACCEDER AHORA',
      scrollCta: 'Conoce qué incluye tu inscripción',
    },
    about: {
      title: 'BASC Perú Training: más que un curso',
      text: 'El I Programa Especializado Internacional está diseñado para formar especialistas en gestión, seguridad y protección de operaciones portuarias. Incluye 120 horas académicas (con visita a Ciudad de Panamá), modalidad híbrida y respaldo institucional de BASC Perú',
      highlights: [
        'Inicio: 10 ago 2026',
        '120 horas académicas',
        'Modalidad híbrida',
        'Hasta 7 certificaciones',
        'Gira en Panamá',
      ],
      cta: 'EMPIEZA TU ESPECIALIZACIÓN',
    },
    modules: {
      title: 'Contenido del programa',
      subtitle:
        '80 horas distribuidas en 5 módulos + 40 horas de curso internacional en Panamá (Canal, Zona Libre y Zona de Economía)',
      items: [
        {
          title: 'Módulo 1: Gestión portuaria en el comercio internacional (20 h)',
          desc: 'Puertos como nodos estratégicos, mapeo de gestión portuaria, riesgos en la cadena de suministro, tipología de puertos, actores clave y marketing portuario',
        },
        {
          title: 'Módulo 2: Operaciones portuarias y tipología de carga (12 h)',
          desc: 'Tipos de carga, equipos portuarios, procedimientos de carga y descarga, seguridad operativa (SOLAS, MARPOL) e indicadores de eficiencia',
        },
        {
          title: 'Módulo 3: Transporte marítimo y multimodalidad (16 h)',
          desc: 'Rutas marítimas, tipos de buques, B/L y carta de porte multimodal, integración con otros modos, logística del contenedor y tendencias digitales',
        },
        {
          title: 'Módulo 4: Normativa, seguridad y protección en puertos (20 h)',
          desc: 'PBIPI, seguridad portuaria, mercancías peligrosas, BASC, OEA, ISO 28000, CTPAT, normativa aduanera, ambiental y planes de contingencia',
        },
        {
          title: 'Módulo 5: Competitividad, innovación y tendencias (12 h)',
          desc: 'Modelos de explotación portuaria, benchmarking, puertos inteligentes (Big Data, blockchain, IoT), integración puerto-ciudad y escenarios futuros',
        },
        {
          title: 'Módulo 6: Curso internacional en Panamá (40 h)',
          desc: 'Gira académica: operatividad portuaria de Perú y puertos panameños, Canal de Panamá, Zona Libre, Zona de Economía e impacto en América Latina',
        },
      ],
      cta: 'VER DETALLE DEL PROGRAMA',
      scrollCta: 'Descubre lo que te llevas al especializarte',
    },
    mentor: {
      title: 'Tu formación, respaldada por BASC Perú Training',
      name: 'Equipo BASC Perú Training',
      bio: 'Capacitación especializada en comercio seguro, gestión portuaria y cadena de suministro. Te acompañan expertos con experiencia en normativa internacional, operaciones portuarias y formación corporativa alineada a los estándares BASC.',
      cta: 'CONOCER BASC PERÚ TRAINING',
    },
    modalidades: {
      title: 'Elige tu plan de especialización',
      subtitle:
        'Selecciona la opción que mejor se adapte a tus objetivos profesionales. Cada modalidad cuenta con certificación oficial de BASC Perú.',
    },
    offer: {
      title: 'Todo lo que incluye tu inscripción',
      items: [
        { label: 'Inicio del programa', value: '10 ago 2026' },
        { label: 'Duración total', value: '120 horas académicas' },
        { label: 'Modalidad', value: 'Híbrida (inicio presencial por módulo)' },
        { label: 'Módulos 1 al 5', value: '80 horas' },
        { label: 'Misión académica internacional en Panamá', value: '40 horas' },
        { label: 'Certificaciones del programa', value: 'Hasta 7' },
      ],
      totalLabel: 'Horas de especialización',
      totalValue: '120 horas',
      priceLabel: 'Inversión',
      price: 'Consultar en BASC Perú',
      note: 'Cupos limitados · Certificación profesional · www.bascperu.org',
      cta: 'INSCRIBIRME AHORA',
      scrollCta: 'Elige tu plan de especialización',
    },
    bonuses: {
      title: 'Beneficios exclusivos del programa',
      items: [
        'Integración de seguridad (BASC, OEA, CTPAT, ISO 28000) con operatividad portuaria avanzada',
        'Hasta 7 certificaciones de alto prestigio nacional e internacional',
        'Misión académica internacional en Panamá: Canal, Zona Libre y Zona de Economía',
        'Conexión directa con operadores del hub logístico internacional',
      ],
    },
    testimonials: {
      title: 'Conoce lo que dicen nuestros participantes',
      items: [
        {
          name: 'María G.',
          role: 'Jefa de Operaciones Portuarias',
          text: 'La integración BASC con operatividad portuaria me permitió aplicar controles reales en terminal',
          photo: publicAsset('/basc/testimonials/avatar-1.png'),
        },
        {
          name: 'Carlos R.',
          role: 'Gerente de Logística Marítima',
          text: 'La gira por el Canal y la Zona Libre de Panamá fue una experiencia única para mi carrera',
          photo: publicAsset('/basc/testimonials/avatar-2.png'),
        },
        {
          name: 'Andrea L.',
          role: 'Especialista en Comercio Exterior',
          text: 'Las certificaciones y el enfoque híbrido combinaron teoría sólida con práctica presencial',
          photo: publicAsset('/basc/testimonials/avatar-3.jpg'),
        },
        {
          name: 'Luis P.',
          role: 'Director de Cadena de Suministro',
          text: '120 horas muy completas: desde normativa internacional hasta el módulo en hub logístico',
          photo: publicAsset('/basc/testimonials/avatar-4.jpg'),
        },
        {
          name: 'Patricia M.',
          role: 'Coordinadora de Seguridad Portuaria',
          text: 'Fortalecí liderazgo en protección portuaria y cadena de suministro del comercio exterior',
          photo: publicAsset('/basc/testimonials/avatar-5.jpg'),
        },
        {
          name: 'Roberto S.',
          role: 'Supervisor de Operaciones',
          text: 'Recomendado para quienes buscan conectar su carrera con el hub logístico de Panamá',
          photo: publicAsset('/basc/testimonials/avatar-6.jpg'),
        },
      ],
    },
    faq: {
      title: 'Preguntas frecuentes',
      items: [
        {
          q: '¿Cuándo inicia el programa?',
          a: 'La primera edición del I Programa Especializado Internacional inicia el 10 de agosto de 2026.',
        },
        {
          q: '¿Cuál es la modalidad?',
          a: 'Modalidad híbrida: cada módulo inicia de forma presencial, complementado con contenido académico estructurado y el módulo internacional en Ciudad de Panamá.',
        },
        {
          q: '¿Cuántas horas y qué incluye la gira en Panamá?',
          a: 'El programa tiene una duración de 120 horas académicas en total. La gira incluye 40 horas en Panamá con visitas y análisis del Canal, Zona Libre y Zona de Economía, además de operatividad portuaria regional.',
        },
        {
          q: '¿Cuántas certificaciones otorga?',
          a: 'El programa contempla hasta 7 certificaciones de alto prestigio nacional e internacional, según el avance y requisitos de cada módulo.',
        },
        {
          q: '¿Para quién está dirigido?',
          a: 'Profesionales en gerencia de logística, operaciones portuarias, protección portuaria y seguridad en la cadena de suministro del comercio exterior.',
        },
        {
          q: '¿Cómo me inscribo o solicito información?',
          a: 'Inscríbete en bascperu.org/basc2.php o escríbenos a fiorella.chocano@bascperu.org / kandy.escobar@bascperu.org, o al 981 289 782.',
        },
      ],
    },
    contact: {
      title: 'Contáctanos',
      items: [
        { type: 'email', label: 'Fiorella Chocano', value: 'fiorella.chocano@bascperu.org' },
        { type: 'email', label: 'Kandy Escobar', value: 'kandy.escobar@bascperu.org' },
        { type: 'phone', label: 'Teléfono', value: '981 289 782' },
      ],
    },
    whatsapp: {
      phone: WHATSAPP_PHONE,
      message:
        'Hola, me interesa el I Programa Especializado Internacional de BASC Perú Training. ¿Podrían brindarme más información?',
      label: 'Escríbenos por WhatsApp',
    },
};

export const programOptions = {
  company: {
    id: '2010',
    key: 'company',
    title: 'Programa Completo: Teórico e Internacional',
    subtitle: 'Estudios completos + Misión académica en Panamá',
    duration: '120 horas académicas',
    price: '$ 2,250.00 + IGV',
    link: 'https://bascperu.org/detalle-curso-basc.php?id=2010',
    icon: 'fa-graduation-cap',
    badge: 'Recomendado',
    features: [
      'Acceso completo a los 6 módulos formativos',
      '80 horas de clases híbridas (virtuales/presenciales)',
      '40 horas de Misión Académica Internacional en Panamá',
      'Hasta 7 certificaciones internacionales',
      'Visita técnica al Canal de Panamá y Zona Libre de Colón',
      'Networking con líderes del Hub Logístico regional'
    ],
    offerItems: [
      { label: 'Inicio del programa', value: '10 ago 2026' },
      { label: 'Duración total', value: '120 horas académicas' },
      { label: 'Modalidad', value: 'Híbrida (inicio presencial por módulo)' },
      { label: 'Misión Académica Panamá', value: '40 horas (15-21 Nov)' },
      { label: 'Inversión Especial', value: '$ 2,250.00 + IGV' },
      { label: 'Certificaciones incluidas', value: 'Hasta 7' }
    ],
    modulesSubtitle: '80 horas distribuidas en 5 módulos + 40 horas de curso internacional en Panamá (Canal, Zona Libre y Zona de Economía)',
    moduleIndices: [0, 1, 2, 3, 4, 5]
  },
  enroll: {
    id: '2011',
    key: 'enroll',
    title: 'Programa Teórico Especializado',
    subtitle: 'Solo estudios teóricos híbridos',
    duration: '80 horas académicas',
    price: '$ 900.00 + IGV',
    link: 'https://bascperu.org/detalle-curso-basc.php?id=2011',
    icon: 'fa-book-open',
    badge: 'Solo Estudios',
    features: [
      'Acceso completo a los Módulos 1 al 5',
      '80 horas de clases híbridas (virtuales/presenciales)',
      'Estudio exhaustivo de normativas (BASC, OEA, ISO 28000)',
      'Certificación como Especialista por BASC Perú',
      'Casos de estudio prácticos y material digital',
      'Ideal si no puedes viajar a Panamá en las fechas indicadas'
    ],
    offerItems: [
      { label: 'Inicio del programa', value: '10 ago 2026' },
      { label: 'Duración teórica', value: '80 horas académicas' },
      { label: 'Modalidad', value: 'Híbrida (inicio presencial por módulo)' },
      { label: 'Misión Académica Panamá', value: 'No incluida' },
      { label: 'Inversión Especial', value: '$ 900.00 + IGV' },
      { label: 'Certificación incluida', value: 'Especialista BASC' }
    ],
    modulesSubtitle: '80 horas de especialización distribuidas en 5 módulos formativos híbridos',
    moduleIndices: [0, 1, 2, 3, 4]
  },
  info: {
    id: '2013',
    key: 'info',
    title: 'Misión Académica en Panamá',
    subtitle: 'Solo visita académica internacional',
    duration: '40 horas académicas',
    price: '$ 1,500.00 + IGV',
    link: 'https://bascperu.org/detalle-curso-basc.php?id=2013',
    icon: 'fa-plane',
    badge: 'Gira',
    features: [
      'Acceso exclusivo al Módulo 6 en Ciudad de Panamá',
      '40 horas de inmersión práctica presencial (15 al 21 nov)',
      'Visita técnica guiada al Canal de Panamá (Esclusas de Miraflores)',
      'Visitas a la Zona Libre de Colón y Zona Especial Panamá Pacífico',
      'Certificado Internacional por la Misión Académica',
      'Ideal si ya tienes la teoría o buscas networking logístico'
    ],
    offerItems: [
      { label: 'Fechas de la misión', value: '15 al 21 de noviembre 2026' },
      { label: 'Duración de la misión', value: '40 horas presenciales' },
      { label: 'Destino', value: 'Ciudad de Panamá, Panamá' },
      { label: 'Visitas técnicas', value: 'Canal de Panamá, Zona Libre' },
      { label: 'Inversión Especial', value: '$ 1,500.00 + IGV' },
      { label: 'Certificación incluida', value: 'Misión Internacional' }
    ],
    modulesSubtitle: '40 horas de curso internacional inmersivo en Panamá (Canal de Panamá, Zona Libre de Colón y Zona Especial Panamá Pacífico)',
    moduleIndices: [5]
  }
};

